import { Pipe } from '@angular/core';

@Pipe({
  name: 'daysOfWeek',
  standalone: true,
})
export class DaysOfWeekPipe {
  transform(value: number): string {
    return ['일', '월', '화', '수', '목', '금', '토'][value];
  }
}
